import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { bookingStatus } from 'types/booking';
import Modal from 'components/ui/Modal';
import { ConfirmButton } from 'components/ui/Button';

import { StyledAbandonButton } from './OnHoldCancellationModal.styles';
const { ON_HOLD } = bookingStatus;

const OnHoldCancellationModal = ({ isOpen, isLoading, onToggle, onSubmit, status = '', mergeThirdPartyModal = false }) => {
  const isOnHold = [ON_HOLD].includes(status);
  return (
    <Modal
      isOpen={isOpen}
      title={<FormattedMessage id="manageBooking.cancelRefund" />}
      subtitle={
        <>
          <FormattedMessage id={isOnHold ? 'manageBooking.cancelRefund.warning.onHold' : 'manageBooking.cancelRefund.warning.tempOnHold'} />
          {mergeThirdPartyModal && (
            <div>
              <strong>
                <FormattedMessage id="manageBooking.cancelRefundThirdParty" />
              </strong>
              <p>
                <FormattedMessage id="manageBooking.cancelRefundThirdPartyMessage" />
              </p>
            </div>
          )}
        </>
      }
      onClose={onToggle}
    >
      <ConfirmButton onClick={onSubmit} loading={isLoading} disabled={isLoading}>
        <FormattedMessage id="manageBooking.confirmCancellation" />
      </ConfirmButton>

      <StyledAbandonButton onClick={onToggle} disabled={isLoading}>
        <FormattedMessage id="manageBooking.abandonCancellation" />
      </StyledAbandonButton>
    </Modal>
  );
};

OnHoldCancellationModal.propTypes = {
  isOpen: PropTypes.bool,
  isLoading: PropTypes.bool,
  onToggle: PropTypes.func,
  onSubmit: PropTypes.func,
  mergeThirdPartyModal: PropTypes.bool,
  status: PropTypes.string
};

export default OnHoldCancellationModal;
